import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
    "inline-flex items-center cursor-pointer justify-center gap-1 whitespace-nowrap rounded-md text-xs font-medium uppercase transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/20 focus-visible:ring-[2px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground shadow-xs hover:bg-primary/90',
                destructive:
                    'bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
                positive:
                    'bg-accent text-white shadow-xs hover:bg-accent/90 focus-visible:ring-accent/20 dark:focus-visible:ring-accent/40 dark:bg-accent/60',
                outline: 'border shadow-xs hover:text-primary border-input',
                secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
                ghost: 'hover:text-accent',
                ghost_primary: 'hover:text-primary',
                ghost_destructive: 'hover:text-destructive',
                ghost_warning: 'hover:text-warning',
                inherit: 'text-inherit hover:text-inherit',
                link: 'text-primary underline-offset-4 hover:underline',
                link_destructive: 'text-destructive underline-offset-4 hover:underline',
                underline: 'text-foreground underline-offset-4 hover:underline',
                edit: 'text-warning hover:text-warning hover:bg-warning/10',
                delete: 'text-destructive hover:text-destructive hover:bg-destructive/10',
                accent: 'text-accent hover:text-accent hover:bg-accent/10',
                continue: 'text-primary hover:text-primary hover:bg-primary/10',
                input: 'selection:bg-primary selection:text-primary-foreground border-input justify-between  border bg-transparent text-xs shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 font-normal normal-case',
                selector:
                    'border shadow-xs hover:bg-faded border-input justify-start normal-case text-secondary focus-visible:ring-0 whitespace-break-spaces text-left',
            },
            size: {
                xs: 'h-7.5 rounded-md px-2.5 has-[>svg]:px-2.5',
                sm: 'h-8 rounded-md px-3 has-[>svg]:px-2.5',
                default: 'h-9 px-4 py-2 has-[>svg]:px-3',
                lg: 'h-10 rounded-md px-6 has-[>svg]:px-4',
                xl: 'h-12 rounded-md px-5 text-xs sm:text-sm',
                icon: 'size-9',
                icon_sm: 'size-7',
                none: 'h-auto px-0 focus-visible:underline focus-visible:ring-0',
            },
            width: {
                default: 'w-auto',
                full: 'w-full',
                narrow: 'w-fit px-0!',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
